import { Link } from 'react-router-dom';
import { Hammer, Twitter, Github, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Product: [
      { label: 'All Tools', href: '/all-tools' },
      { label: 'Crypto Calculators', href: '/crypto-calculators' },
      { label: 'Top Tools', href: '/top-tools' },
      { label: 'Latest Updates', href: '/latest-updates' },
      { label: 'Blog', href: '/blog' },
      { label: 'Sitemap', href: '/sitemap' },
    ],
    Categories: [
      { label: 'Text Tools', href: '/category/text-tools' },
      { label: 'Developer Tools', href: '/category/developer-tools' },
      { label: 'SEO Tools', href: '/category/seo-tools' },
      { label: 'Generators', href: '/category/generators' },
      { label: 'Calculator Tools', href: '/category/calculator-tools' },
    ],
    'Crypto Tools': [
      { label: 'Bitcoin Calculator', href: '/tools/bitcoin-profit-calculator' },
      { label: 'Ethereum Calculator', href: '/tools/ethereum-profit-calculator' },
      { label: 'Crypto Tax Calculator', href: '/tools/crypto-tax-calculator' },
      { label: 'Crypto ROI Calculator', href: '/tools/crypto-roi-calculator' },
      { label: 'All Crypto Tools', href: '/crypto-calculators' },
    ],
    Popular: [
      { label: 'JSON Formatter', href: '/tools/json-formatter' },
      { label: 'Password Generator', href: '/tools/password-generator' },
      { label: 'QR Code Generator', href: '/tools/qr-code-generator' },
      { label: 'Base64 Encoder', href: '/tools/base64-encoder' },
    ],
  };

  return (
    <footer className="border-t border-border bg-muted/30" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Hammer className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-bold font-['Plus_Jakarta_Sans']">ToolsForge</span>
            </Link>
            <p className="text-sm text-muted-foreground mb-4">
              Your one-stop marketplace for AI tools and digital utilities.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-semibold mb-4 text-sm">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} ToolsForge. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-muted-foreground">
            <Link to="#" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
